<template>
	<base-modal
		:showCloseButton="true"
		:opened="isOpen"
		@close="close"
		max-width="lg"
	>
		<template #body>
			<div class="p-6 bg-white">
				<div
					class="flex flex-col items-center text-center space-y-6 md:space-y-8"
				>
					<h2 id="modal-headline" class="text-4xl font-bold text-gray-900">
						No Problem!
					</h2>
					<div class="w-full max-w-md">
						<div
							class="bg-yellow-50 rounded-xl shadow-sm px-6 py-6 space-y-6"
						>
              <div class="space-y-2">
							<p class="text-xl text-gray-800 font-medium">
								How about
							</p>
							<p class="text-3xl font-bold text-gray-900">
								$49 a month?
								<span class="text-green-700 italic">50% off</span>
							</p>
              </div>
							<button
								type="button"
								class="mt-4 w-full rounded-md bg-yellow-300 text-gray-900 font-semibold shadow-sm px-4 py-3 hover:bg-yellow-200 transition"
								@click="handleAccept"
							>
								🎉 Accept Offer 🎉
							</button>
						</div>
					</div>
					<button
						type="button"
						class="text-sm text-gray-600 hover:text-gray-800 underline"
						@click="close"
					>
						I don't want to keep my access <span aria-hidden="true">😢</span>
					</button>
				</div>
			</div>
		</template>
	</base-modal>
</template>

<script lang="ts" setup>
import { computed, watch } from "vue";
import { analytics } from "@/services/segment.ts";
import { getEnv } from "@/env";
import BaseModal from "./BaseModal.vue";
import { useAccessRenewalOfferModalStore } from "@/stores/accessRenewalOfferModalStore";
import { useUserStore } from "@/stores/userStore";
import { storeToRefs } from "pinia";
import { useAcademicStudentAccessExpiration } from "@/hooks/useAcademicStudentAccessExpiration";

const modalStore = useAccessRenewalOfferModalStore();
const userStore = useUserStore();
const { userObj } = storeToRefs(userStore);
const { countdown } = useAcademicStudentAccessExpiration(userObj);

const isOpen = computed(() => {
	return modalStore.isOpen;
});

const getDaysRemaining = () => countdown.value.days;

const close = () => {
	analytics.track('B2B to D2C Final Offer Declined', { product: userObj.value?.subscription_plan, days_remaining: getDaysRemaining() });
	modalStore.close();
};

const handleAccept = () => {
	analytics.track('B2B to D2C Final Offer Accepted', { product: userObj.value?.subscription_plan, days_remaining: getDaysRemaining() });
	const params = new URLSearchParams(window.location.search);
	params.set("plan", getEnv('VITE_RENEWAL_OFFER_PLAN', 'professional'));
	params.set("frequency", getEnv('VITE_RENEWAL_FINAL_OFFER_FREQUENCY', '1m'));
	if (getEnv('VITE_RENEWAL_FINAL_OFFER_COUPON_CODE')) {
		params.set("final_offer", "1");
	}
	window.location.href = `/account/checkout/offer-checkout-reg?${params.toString()}`;
};

watch(isOpen, (val) => {
	if (val) analytics.track('B2B to D2C Final Offer Viewed', { product: userObj.value?.subscription_plan, days_remaining: getDaysRemaining() });
});
</script>
